module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "notice-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.notice.src,
      "alt": ""
    }
  })]), _vm._v("\n         " + _vm._s(_vm.notice.title) + "\n        "), (_vm.num === 2) ? [_c('a', {
    staticClass: "pull-right a-more",
    attrs: {
      "href": "purchase.html?num=2"
    }
  }, [_vm._v("更多>")])] : _vm._e(), _vm._v(" "), (_vm.morelink) ? [_c('a', {
    staticClass: "pull-right a-more",
    attrs: {
      "target": "_blank",
      "href": _vm.morelink
    }
  }, [_vm._v("更多>")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body min-height"
  }, [(_vm.notice.content) ? _vm._l((_vm.notice.content), function(info) {
    return _c('div', [_c('a', {
      staticClass: "list-group-item list-padding",
      attrs: {
        "href": "javascript:;",
        "title": info.messageTitle || info.title
      },
      on: {
        "click": function($event) {
          return _vm.detailed(info)
        }
      }
    }, [_c('span', {
      staticClass: "list-dot"
    }, [_vm._v("·")]), _vm._v("\n             " + _vm._s(info.messageTitle || info.title) + "\n          ")])])
  }) : (!_vm.notice.content && _vm.notice.title != '友情链接') ? [_c('p', {
    staticClass: "notcie-error-handling"
  }, [_vm._v("暂无数据")])] : _vm._e(), _vm._v(" "), (_vm.notice.title == '友情链接') ? void 0 : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1957e703","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice.vue
// module id = 186
// module chunks = 4 8